<script>
import { required, minLength, numeric } from "vuelidate/lib/validators";
import validationMessages from '@/components/validations'
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Fixtures from "@/services/Fixtures";
import Customers from "@/services/Customers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
    components: {
        validationMessages, vueDropzone: vue2Dropzone, flatPickr
    },
    data() {
        return {
            csrf_token: localStorage.getItem('csrf_token'),
            name: '',
            currency:'EUR',
            nft_pack_type:'match',
            attributes:{},
            start_time:'',
            active: 1,
            source:'AZERION',
            nft_pack_images:[
                { image_url: '', rarity: 0, label: 'Common' },
                { image_url: '', rarity: 1, label: 'Silver' },
                { image_url: '', rarity: 2, label: 'Gold' },
            ],
            selectedMatch: {},
            selected_group_id: '',
            matches:{},
            photoDeletedCompanyImage: false,
            photoDeletedLogoUrl: false,
            submitted: false,
            showModal: false,
            tryingToEdit: false,
            loadMatches:true,
            datetimeconfig: {
                enableTime: true,
                time_24hr: true,
                minuteIncrement: 1,
                dateFormat: "Y-m-d H:i:S",
            },
            dropzoneOptions_primary: {
                url: '/',
                autoProcessQueue: false,
                addRemoveLinks: true,
                thumbnailWidth: 600,
                thumbnailHeight: 600,
                thumbnailMethod: 'contain',
                maxFilesize: 4,
                acceptedFiles: 'image/jpeg,image/png,image/bmp,image/webp',
                maxFiles: 1,
            },
            dateconfig: {
                enableTime: false,
                dateFormat: "Y-m-d",
                minDate: new Date(),
            },
            timeconfig: {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                minuteIncrement: 1,
                dateFormat: "H:i",
                allowInput: true
            },
            currencyOptions: [
                { value: 'EUR', text: 'EUR' },
            ],
            nftPackTypes: [
                { value: 'match', text: 'Match' },
            ]
        };
    },
 
    validations: {
        selectedMatch: {
            required
        },
        name: {
            required
        },
        currency: {
            required
        },
        nft_pack_type: {
            required
        },
        attributes: {
            required
        },
        start_time: {
            required
        },
        active: {
            required
        },
    },
    methods: {
        async getMatches(){
            try{
            this.loadMatches = true;
            const [matchesResponse, packsResponse] = await Promise.all([
                Fixtures.getMatches('type=FUTURE'),
                Customers.getNftPacks().catch(() => ({ data: { list: [] } })),
            ]);

            const existingMatchIds = new Set(
                (packsResponse.data?.list || []).map((pack) => {
                    const dashIndex = pack.id.indexOf('-');
                    return dashIndex >= 0 ? pack.id.slice(dashIndex + 1) : pack.id;
                })
            );

            const now = Date.now();

            // Future home matches without an existing NFT pack (same rules as createNFTCollectibles cron)
            this.matches = (matchesResponse.data.matches || [])
                .filter((match) => {
                    if (!match.date_time) return false;
                    if (match.match_location && match.match_location !== 'home') return false;
                    const matchTime = match.unix_datetime
                        ? match.unix_datetime * 1000
                        : new Date(match.date_time).getTime();
                    if (isNaN(matchTime) || matchTime <= now) return false;
                    return !existingMatchIds.has(match.match_id);
                })
                .map((match) => ({
                    value: match,
                    text: `${match.home_team_name} - ${match.away_team_name} (${match.date_formatted || match.date_time})`,
                }));

                this.loadMatches = false;
            }catch(error){
               this.error = error.response && error.response.data && error.response.data.error
                    ? error.response.data.error
                    : "";
              this.failedmsg(this.error);
              this.loadMatches= false;
            }
        },

        onMatchSelected(){
            this.name = `${this.selectedMatch.home_team_name} - ${this.selectedMatch.away_team_name}`;
            this.start_time = this.selectedMatch.date_time;
            this.attributes = {
                "venue":this.selectedMatch.venue_name,
                "match_id":this.selectedMatch.match_id,
                "date_time":this.selectedMatch.date_time,
                "description":this.name
            };
        },

        async addNFTPack() {
            this.tryingToEdit = true;
            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.tryingToEdit = false;
                return;
            }

            try {
                const formData = new FormData();
                formData.append('match_id', this.attributes.match_id);
                formData.append('name', this.name);
                formData.append('currency', this.currency);
                // formData.append('state', 0);
                formData.append('type', this.nft_pack_type);
                Object.entries(this.attributes).forEach(([key, value]) => {
                    formData.append(`attributes[${key}]`, value);
                });
                formData.append('start_time', String(Math.floor(new Date(this.start_time).getTime() / 1000)));
                formData.append('active', this.active);
                formData.append('source', this.source);

                const uploadedImages = this.nft_pack_images.filter(img => img.file);
                uploadedImages.forEach((img, index) => {
                    formData.append(`nftPackImages[${index}][rarity]`, img.rarity);
                    formData.append(`nftPackImages[${index}][image_url]`, img.file);
                });

                await Customers.createNFTPack(formData);
                this.successmsg("NFT Pack created");
                this.closeModal();
            } catch (error) {
                this.error = error.response && error.response.data && error.response.data.error
                    ? error.response.data.error
                    : "";
                this.failedmsg(this.error);
            } finally {
                this.refreshData();
                this.tryingToEdit = false;
            }
        },

        selectPackImage(files, rarity) {
            const ref = `dropzone_rarity_${rarity}`;
            setTimeout(() => {
                const dz = Array.isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref];
                if (!dz) return;
                if (files.length > 1) {
                    files.forEach(f => dz.removeFile(f));
                    return;
                }
                const idx = this.nft_pack_images.findIndex(i => i.rarity === rarity);
                if (idx !== -1) this.nft_pack_images[idx].file = files[0] || null;
            }, 250);
        },


        refreshData() {
            this.$emit('onRefresh')
        },
        closeModal() {
            this.showModal = false
            this.resetProps()
        },

        async syncData(){
            await this.getMatches();
        },
        resetProps() {
            this.name = "";
            this.currency = "EUR";
            // this.state = 0;
            this.nft_pack_type = "match";
            this.attributes = {};
            this.start_time = "";
            // this.active = 0;
            this.source = "Azerion";
            this.nft_pack_images = [
                { image_url: '', rarity: 0, label: 'Common' },
                { image_url: '', rarity: 1, label: 'Silver' },
                { image_url: '', rarity: 2, label: 'Gold' },
            ];
            this.selectedMatch = {};
            this.matches = {};
            this.image_url = null;
            this.submitted = false;
        }
    },
};
</script>

<template>
    <b-modal v-model="showModal" @shown="syncData" size="xl" @hidden="resetProps" id="add_nft_pack" hide-header hide-footer
        body-class="p-0" centered>
        <div class="add-nft-pack-modal">

            <!-- HERO -->
            <header class="add-nft-pack-modal__hero">
                <h2>Add New NFT Pack</h2>
                <p>Create an NFT Pack for a match</p>
            </header>
            <div v-if="loadMatches" class="d-flex align-items-center justify-content-center">
                <b-spinner ></b-spinner>
            </div>
            <b-form v-else @submit.prevent="addNFTPack">
                <div v-if="matches.length">
                    <!-- MATCH -->
                    <section class="nft-pack-card">
                        <header class="nft-pack__header">
                            <h3>Match</h3>
                            <p>Select the match for which the pack will be created</p>
                        </header>

                        <b-form-group label="Match *" class="mb-0">
                            <b-form-select @change="onMatchSelected" v-model="selectedMatch" :options="matches"
                                :class="{ 'is-invalid': submitted && $v.selectedMatch.$error }" />
                            <validationMessages v-if="submitted" :fieldName="'Match'"
                                :validationName="$v.selectedMatch" />
                        </b-form-group>
                    </section>

                    <!-- NFT PACK -->
                    <section class="nft-pack-card">
                        <header class="nft-pack__header">
                            <h3>Pack Details</h3>
                            <p>Enter the details for this pack</p>
                        </header>

                        <b-form-group label="Pack Name *" class="mb-4">
                            <b-form-input v-model.trim="name" :class="{ 'is-invalid': submitted && $v.name.$error }"
                                disabled />
                            <validationMessages v-if="submitted" :fieldName="'Pack Name'" :validationName="$v.name" />
                        </b-form-group>

                        <b-form-group label="Start Time *" class="mb-4">
                            <flat-pickr v-model="start_time" :config="datetimeconfig" class="form-control" disabled
                                :class="{ 'is-invalid': submitted && $v.start_time.$error }" />
                            <validationMessages v-if="submitted" :fieldName="'Start Time'"
                                :validationName="$v.start_time" />
                        </b-form-group>

                        <b-form-group label="Currency *" class="mb-4">
                            <b-form-select v-model="currency" :options="currencyOptions"
                                :class="{ 'is-invalid': submitted && $v.selectedMatch.$error }" />
                            <validationMessages v-if="submitted" :fieldName="'NFT Pack Currency'"
                                :validationName="$v.currency" />
                        </b-form-group>

                        <b-form-group label="Type *" class="mb-4">
                            <b-form-select v-model="nft_pack_type" :options="nftPackTypes"
                                :class="{ 'is-invalid': submitted && $v.selectedMatch.$error }" />
                            <validationMessages v-if="submitted" :fieldName="'NFT Pack Type'"
                                :validationName="$v.nft_pack_type" />
                        </b-form-group>

                        <b-form-group label="Active" class="mb-0">
                            <div class="form-check form-switch form-switch-lg mb-0">
                                <input v-model="active" type="checkbox" class="form-check-input" :true-value="1"
                                    :false-value="0" disabled />
                            </div>
                        </b-form-group>

                    </section>



                    <!-- IMAGES -->
                    <section class="nft-pack-card">
                        <header class="nft-pack-card__header">
                            <h3>Pack Images</h3>
                            <p>Upload one image per rarity tier.</p>
                        </header>

                        <div class="row g-3">
                            <div v-for="img in nft_pack_images" :key="img.rarity" class="col-12 col-md-4">
                                <label class="d-block mb-2 fw-semibold">{{ img.label }}</label>
                                <div class="poll-upload poll-upload--compact">
                                    <vue-dropzone :id="`dropzone_rarity_${img.rarity}`"
                                        :ref="`dropzone_rarity_${img.rarity}`" :use-custom-slot="true"
                                        :options="dropzoneOptions_primary"
                                        @vdropzone-files-added="files => selectPackImage(files, img.rarity)"
                                        no-progress-bar>
                                        <div class="poll-upload__placeholder">
                                            <i class="uil uil-import"></i>
                                            <span>Click or drop</span>
                                            <small>PNG, JPG up to 4MB</small>
                                        </div>
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- FOOTER -->
                    <footer class="add-nft-pack-modal__footer">
                        <b-button variant="outline-secondary" @click="closeModal">
                            Cancel
                        </b-button>

                        <b-button variant="dark" type="submit" :disabled="tryingToEdit">
                            <b-spinner v-if="tryingToEdit" small class="me-2" />
                            Create NFT Pack
                        </b-button>
                    </footer>
                </div>
                <div v-else class="d-flex align-items-center justify-content-center">
                    <span class="text-center">No Matches Available!</span>
                </div>
              

            </b-form>
        </div>
    </b-modal>
</template>

<style scoped>
.add-nft-pack-modal {
    padding: 32px;
    background: #f7f8fb;
}

.add-nft-pack-modal__hero {
    margin-bottom: 24px;
}

.add-nft-pack-modal__hero h2 {
    font-weight: 600;
    font-size: 28px;
    margin-bottom: 8px;
    color: #151a2d;
}

.add-nft-pack-modal__hero p {
    margin: 0;
    color: #5f6b7d;
    font-size: 16px;
}

.nft-pack-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 28px;
    margin-bottom: 24px;
    box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.nft-pack-card__header h3 {
    margin-bottom: 4px;
    font-size: 20px;
    font-weight: 600;
    color: #151a2d;
}

.nft-pack-card__header p {
    margin-bottom: 24px;
    color: #5f6b7d;
}

.poll-datetime {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.poll-datetime__label {
    font-weight: 600;
    color: #151a2d;
}

.nft-pack_datetime_inputs {
    display: flex;
    gap: 12px;
    align-items: center;
}

.poll-input-icon {
    position: relative;
    flex: 1;
}

.poll-input-icon__icon {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #5f6b7d;
    font-size: 18px;
    cursor: pointer;
    pointer-events: auto;
}

.poll-input-icon .form-control {
    width: 100%;
}

.nft-pack_datetime_inputs .form-control {
    padding: 12px 16px;
    border-radius: 12px;
    background: #f1f3f7;
    border: 1px solid transparent;
}

.nft-pack_datetime_inputs .form-control:focus {
    border-color: #6366f1;
    background: #ffffff;
    box-shadow: none;
}

.poll-upload {
    border: 2px dashed #d3d8e6;
    border-radius: 16px;
    background: #f7f8fb;
    padding: 32px;
    transition: border-color 0.2s ease, background 0.2s ease;
}

.poll-upload--compact {
    padding: 14px;
}

.poll-upload--compact .poll-upload__placeholder {
    font-size: 12px;
}

.poll-upload--compact .poll-upload__placeholder i {
    font-size: 22px;
}

.poll-upload--compact ::v-deep .dropzone {
    min-height: 340px;
    padding: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.poll-upload--compact ::v-deep .dz-message {
    margin: 0;
    width: 100%;
    text-align: center;
}

.poll-upload--compact ::v-deep .dz-preview {
    margin: 0;
    width: 100%;
    min-height: 340px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.poll-upload--compact ::v-deep .dz-preview .dz-image {
    width: 100% !important;
    height: 300px !important;
    border-radius: 8px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.poll-upload--compact ::v-deep .dz-preview .dz-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    object-position: center !important;
    top: auto !important;
    left: auto !important;
    position: static !important;
    transform: none !important;
}

.poll-upload--compact ::v-deep .dz-preview .dz-details {
    display: none;
}

.poll-upload.is-invalid {
    border-color: #f97373;
}

.poll-upload.has-error {
    border-color: #f97373;
    background: #fff5f5;
}

.poll-upload__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #5f6b7d;
    font-size: 14px;
}

.poll-upload__placeholder i {
    font-size: 32px;
    color: #151a2d;
}

.poll-upload__placeholder small {
    color: #a0aec0;
}

.add-nft-pack-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 12px;
}

@media (max-width: 767.98px) {
    .add-nft-pack-modal {
        padding: 20px;
    }

    .nft-pack-card {
        padding: 20px;
    }

    .nft-pack_datetime_inputs {
        flex-direction: column;
        align-items: stretch;
    }
}
</style>